import './DialogControl.scss';
import React, { useEffect, useMemo, useState } from 'react';
import FocusTrap from 'focus-trap-react';
import ButtonControl from '../ButtonControl';
import _ from 'lodash'

let dialogControlIdCounter = 0;

export default function DialogControl({
    openDialog,
    title,
    subTitle,
    subTitle2,
    okText,
    cancelText,
    onCancel,
    onCustomCenter,
    disabledCustomCenter,
    loadingCustomCenter,
    customCenterText,
    customCenterType,
    disableOk,
    disableXButton,
    disableCancel,
    excludeCancel,
    onOk,
    loadingOk,
    onNext,
    onPrevious,
    enableNext,
    enableSave,
    loadingSave,
    isPrevious,
    isYes,
    onYes,
    isNo,
    onNo,
    isConfirm,
    onSave,
    customSave,
    customNext,
    customYes,
    children,
    nextText,
    isSave,
    hideButtonRow,
    className,
    footerClassName,
    innerclassName }) {

    const [open, setOpen] = useState(openDialog);
    const [saveDisabled, setSaveDisabled] = useState(false)
    const [loading, setLoading] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const titleId = useMemo(() => `dialog-control-title-${++dialogControlIdCounter}`, []);
    useEffect(() => {
        setOpen(openDialog);
        setLoading(false);
    }, [openDialog]);

    useEffect(() => {
        setLoading(loadingSave);
    }, [loadingSave]);

    useEffect(() => {
        if (enableSave !== null && enableSave !== undefined) {
            if (enableSave === true) {
                setSaveDisabled(false);
            } else {
                setSaveDisabled(true);
            }
        }
    }, [enableSave]);

    const handleOnOk = async (e) => {
        if (onOk) {
            setLoading(true);
            const result = await onOk(e);

            if (result !== undefined) {
                if (result?.Success) {
                    setErrorMessages([]);
                    setLoading(false);
                    setOpen(false);
                }
                else if (!result?.Success && !result?.skipError) {
                    setLoading(false);
                    const msg = (result?.MessageDetails && result?.MessageDetails.length > 0 ? result?.MessageDetails : (result?.messages ?? result?.Messages ?? (result?.Message?.DisplayMessage ? [result?.Message?.DisplayMessage] : ["An unknown error has occurred."])));
                    setErrorMessages([...msg]);
                }
                else {
                    setLoading(false);
                }
            }
            else {
                setLoading(false);
            }
        }
        else {
            setLoading(false);
            setOpen(false);
        }
    }

    const handleOnSave = async (e) => {
        if (onSave) {
            setLoading(true);
            await onSave(e);
        }
    }

    const handleOnNext = async (e) => {
        if (onNext) {
            setLoading(true);
            await onNext(e);
        }
    }

    const handleOnYes = async (e) => {
        if (onYes) {
            setLoading(true);
            await onYes(e);
            setLoading(false);
        }
    }

    const handleOnExit = async () => {
        if (onCancel) {
            await onCancel();
        }

        setOpen(false);
        setLoading(false);
        setErrorMessages([]);
    }

    const handleOnCancel = async () => {
        if (!loading) {
            let result = undefined;
            if (onCancel)
                result = await onCancel();

            if (result === undefined || result?.Success) {
                setOpen(false);
                setLoading(false);
                setErrorMessages([]);
            }
        }
    }

    const handleOnCustomCenter = async (e) => {
        if (onCustomCenter) {
            setLoading(true);
            const result = await onCustomCenter(e);
            if (result !== undefined) {
                if (result?.Success) {
                    setErrorMessages([]);
                    setLoading(false);
                    setOpen(false);
                }
                else if (!result?.Success && !result?.skipError) {
                    setLoading(false);
                    const msg = (result?.MessageDetails && result?.MessageDetails.length > 0 ? result?.MessageDetails : (result?.messages ?? result?.Messages ?? (result?.Message?.DisplayMessage ? [result?.Message?.DisplayMessage] : ["An unknown error has occurred."])));
                    setErrorMessages([...msg]);
                }
                else {
                    setLoading(false);
                }
            } else {
                setLoading(false)
            }
        }
        else {
            setLoading(false);
        }
    }

    return <>

        {open && <><div className={`dialog-control__block-ui`}></div>
            <div className={`dialog-control`}>
                <FocusTrap
                    focusTrapOptions={{
                        // Escape is handled ourselves (below) so it always goes through the
                        // same close semantics as the X button, regardless of which action
                        // (Ok/Cancel/Save/etc.) is responsible for the dialog's own open/close
                        // state. Disabling escapeDeactivates avoids focus-trap-react firing its
                        // own deactivation/onDeactivate cycle that would fight with that state.
                        escapeDeactivates: false,
                        clickOutsideDeactivates: false,
                        returnFocusOnDeactivate: true,
                        // Dropdown/picker controls (rsuite SelectPicker/CheckPicker/TreePicker/
                        // CheckTreePicker, MUI Autocomplete/Popover/Menu) render their open menu
                        // via a portal appended outside this trap's DOM subtree. Without this,
                        // focus-trap blocks all pointer interaction with that portaled content
                        // (mousedown/click get preventDefault'd as "outside clicks"), making any
                        // such control inside a dialog completely unusable. Allow outside
                        // clicks that land inside one of these known portal roots through.
                        allowOutsideClick: (event) => {
                            const target = event?.target;
                            return !!(target && target.closest && target.closest(
                                '.rs-picker-menu, .rs-picker-daterange-menu, .rs-anim-fade, ' +
                                '.MuiPopover-root, .MuiPopper-root, .MuiAutocomplete-popper, .MuiModal-root'
                            ));
                        },
                    }}
                >
                <div className={`dialog ${className ? className : ''}`} role='dialog' aria-modal='true' aria-labelledby={titleId} onKeyDown={(e) => { if (e.key === 'Escape') { e.stopPropagation(); handleOnExit(); } }}>
                    <div className='dialog__header'>
                        <div className='dialog__header-title'>
                            <h2 id={titleId}>{title}</h2>
                            {subTitle && <h5>{subTitle}</h5>}
                            {subTitle2 && <h5>{subTitle2}</h5>}
                        </div>
                        {!disableXButton && <button type='button' className='dialog__header-close' onClick={handleOnExit} aria-label='Close dialog' title='Close dialog'>
                            <span aria-hidden='true'>X</span>
                        </button>}
                    </div>
                    {(children || errorMessages?.length > 0) &&
                        <div className={`dialog__inner ${className ?? ''} ${innerclassName ?? ''}`}>
                            {errorMessages.length > 0 &&
                                <div className='dialog__error' >
                                    {_.map(errorMessages, (msg, i) => <div key={`dialog-error-${i}`}>{msg}</div>)}
                                </div>
                            }
                            {children}
                        </div>
                    }
                    {!hideButtonRow &&
                        <div className={`dialog__footer ${footerClassName ?? ''}`}>
                            {((cancelText || onCancel) && !excludeCancel) &&
                                < ButtonControl type={'cancel'} disabled={loading || disableCancel} className={'dialog-btn'} onClick={handleOnCancel}>
                                    {cancelText ?? 'Cancel'}
                                </ButtonControl>}

                            {(onPrevious && isPrevious) &&
                                <ButtonControl loading={loading} type={'okay'} className={'dialog-btn dialog-btn-previous'} onClick={onPrevious}>
                                    {'Previous'}
                                </ButtonControl>}
                            {((nextText || onNext) && !isSave && !customNext) &&
                                <ButtonControl disabled={!enableNext} loading={loading} type={'okay'} className={'dialog-btn'} onClick={onNext}>
                                    {nextText ?? 'Next'}
                                </ButtonControl>}
                            {(((nextText || onNext) && customNext) && !isSave) &&
                                <ButtonControl disabled={!enableNext} loading={loading} type={'okay'} className={'dialog-btn'} onClick={handleOnNext}>
                                    {nextText ?? 'Next'}
                                </ButtonControl>}
                            {(isSave && onSave) &&
                                <ButtonControl disabled={saveDisabled} loading={loading} type={'okay'} className={'dialog-btn'} onClick={onSave}>
                                    {'Save'}
                                </ButtonControl>
                            }
                            {(customSave && onSave) &&
                                <ButtonControl disabled={saveDisabled} loading={loading} type={'okay'} className={'dialog-btn'} onClick={handleOnSave}>
                                    {'Save'}
                                </ButtonControl>
                            }
                            {(isNo) &&
                                <ButtonControl loading={customYes ? false : loading} type={'okay'} className={'dialog-btn'} onClick={onNo}>
                                    {'No'}
                                </ButtonControl>
                            }
                            {(isYes && !customYes) &&
                                <ButtonControl loading={loading} type={'okay'} className={'dialog-btn'} onClick={onYes}>
                                    {'Yes'}
                                </ButtonControl>
                            }
                            {(isConfirm) &&
                                <ButtonControl loading={loading} type={'okay'} className={'dialog-btn'} onClick={handleOnYes}>
                                    {'Confirm'}
                                </ButtonControl>
                            }
                            {(customYes && onYes) &&
                                <ButtonControl loading={loading} type={'okay'} className={'dialog-btn'} onClick={handleOnYes}>
                                    {'Yes'}
                                </ButtonControl>
                            }
                            {(customCenterText || onCustomCenter) &&
                                <ButtonControl type={customCenterType ?? 'okay'} loading={loading || loadingCustomCenter} disabled={disableOk || disabledCustomCenter} className={'dialog-btn'} onClick={handleOnCustomCenter}>
                                    {customCenterText ?? 'Custom'}
                                </ButtonControl>}
                            {(okText || onOk) &&
                                <ButtonControl loading={loading || loadingOk} disabled={disableOk} type={'okay'} className={'dialog-btn'} onClick={handleOnOk}>
                                    {okText ?? 'Ok'}
                                </ButtonControl>}

                        </div>
                    }
                </div>
                </FocusTrap>
            </div></>
        }
    </>
}